import React, { useState, useEffect } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Home, Search, Plus, MessageCircle, User } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from '../common/CookieBanner';

import { useAuth } from '../auth/AuthContext';

function Layout() {
    const { isAuthenticated } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (!isAuthenticated) {
            setUnreadCount(0);
            return;
        }
        fetch(`${window.location.protocol}//${window.location.host}/api/auth/messages.php?unread=true`, {
            credentials: 'include'
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) setUnreadCount(data.count || 0);
        })
        .catch(() => {});
    }, [isAuthenticated]);

    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
                <div className="container mx-auto px-3 sm:px-6 lg:px-8 py-3 pb-20 md:py-8 md:pb-8">
                    <Outlet />
                </div>
            </main>
            <Footer />
            <CookieBanner />


            {/* Mobile Bottom Navigation */}
            <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-gray-200 shadow-2xl z-50">
                <div className="flex justify-around py-3">
                    <Link to="/" className="flex flex-col items-center text-orange-500">
                        <Home className="w-6 h-6" />
                        <span className="text-xs font-semibold">Home</span>
                    </Link>
                    <Link to="/products" className="flex flex-col items-center text-gray-600 hover:text-orange-500 transition-colors">
                        <Search className="w-6 h-6" />
                        <span className="text-xs">Suchen</span>
                    </Link>
                    <Link to="/products/create" className="flex flex-col items-center -mt-2">
                        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-full p-2.5 shadow-lg">
                            <Plus className="w-5 h-5 text-white" />
                        </div>
                        <span className="text-xs text-gray-600 mt-0.5">Verkaufen</span>
                    </Link>
                    <Link to="/messages" className="flex flex-col items-center text-gray-600 hover:text-orange-500 transition-colors relative">
                        <MessageCircle className="w-6 h-6" />
                        {isAuthenticated && unreadCount > 0 && (
                            <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                {unreadCount}
                            </span>
                        )}
                        <span className="text-xs">Chats</span>
                    </Link>
                    <Link to="/profile" className="flex flex-col items-center text-gray-600 hover:text-orange-500 transition-colors">
                        <User className="w-6 h-6" />
                        <span className="text-xs">Profil</span>
                    </Link>
                </div>
            </nav>
        </div>
    );
}

export default Layout;
